// extracted by mini-css-extract-plugin
export default {"root":"sidebar-desktop-module__root--d7MBC","rootActive":"sidebar-desktop-module__rootActive--xsQ6x"};